import ClubZeroBill from '@containers/IQOSUniverse/articles/ClubZeroBill/ClubZeroBill';
export default ClubZeroBill;
